<script setup>
import { ref, watch } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAlert } from 'dashboard/composables';
import SectionLayout from './SectionLayout.vue';
import Switch from 'next/switch/Switch.vue';

const isEnabled = ref(false);
const { currentAccount, updateAccount } = useAccount();

watch(
  currentAccount,
  () => {
    const { auto_prioritize_unread } = currentAccount.value?.settings || {};
    isEnabled.value = !!auto_prioritize_unread;
  },
  { deep: true, immediate: true }
);

const toggleAutoPrioritizeUnread = async () => {
  const newValue = !isEnabled.value;
  isEnabled.value = newValue;
  try {
    await updateAccount({ auto_prioritize_unread: newValue });
    useAlert('Pengaturan prioritas percakapan belum dibaca berhasil diperbarui.');
  } catch (error) {
    isEnabled.value = !newValue;
    useAlert('Gagal memperbarui pengaturan prioritas percakapan.');
  }
};
</script>

<template>
  <SectionLayout
    title="Prioritaskan Percakapan Belum Dibaca"
    description="Otomatis menempatkan percakapan dengan pesan baru yang belum dibaca (badge hijau) di posisi paling atas berdasarkan waktu terbaru."
    with-border
  >
    <template #headerActions>
      <div class="flex justify-end">
        <Switch :model-value="isEnabled" @click="toggleAutoPrioritizeUnread" />
      </div>
    </template>
  </SectionLayout>
</template>
